import Head from 'next/head';

import Props from './Layout.types';

import { constants } from '../../constants';
import { useEffect, useState } from 'react';
import { isBulgariFlowFn, updateDataLayerObj } from '../../utils';
import { useSession } from '@marriott/mi-headless-utils';

const { POLITE } = constants;

export const Layout = ({
  children,
  title,
  metaNames,
  metaProps,
  pageIdentifier,
  model,
  ariaHidden = true,
  ariaLive = 'polite',
  isACRSProperty,
  isERSProperty,
}: Props) => {
  const [isBulgariFlow, setIsBulgariFlow] = useState(false);
  const { isACDLenabled } = useSession();

  useEffect(() => {

    /**
      * Invoke the datalayer update utility only for non-ACDL pages
      * This condition will not be required in future and will be cleaned up once we completely migrate to ACDL.
      * Mutating window.dataLayer doesn't changes the reference, hence not added in the useEffect() dependency array.
    */
    if(!isACDLenabled && window.dataLayer) {
      updateDataLayerObj(window.dataLayer)
    }
    setIsBulgariFlow(isBulgariFlowFn());
  }, [isACDLenabled]);
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <title>{title}</title>
        <link rel="icon" type="image/x-icon" href={model.favIcon} />
        {metaNames?.map(metaName => (
          <meta name={metaName.name} content={metaName.value} key={metaName.value}></meta>
        ))}
        {metaProps?.map(metaProperty => (
          <meta property={metaProperty.name} content={metaProperty.value} key={metaProperty.value}></meta>
        ))}
        <link rel="canonical" href={model.canonical} />
        <script src={model.launchScript} async></script>
        <script src={model.dataLayerScript} async></script>
      </Head>
      <div className={'brand-css'} aria-hidden={ariaHidden} aria-live={ariaLive} aria-atomic={ariaLive === POLITE}>
        <div
          id="main-content"
          className={`${model.cssClassNames} ${pageIdentifier} ${isBulgariFlow && 'bulgari-main-content'} ${
            isACRSProperty ? 'is-acrs' : isERSProperty ? 'is-ers' : ''
          }`}
        >
          {children}
        </div>
      </div>
    </>
  );
};
